import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import Placeholder from 'components/consumer/Placeholder';
import Attribute from './components/Attribute';
const PDPSellingAttributesUI = t0 => {
  const $ = _c(9);
  const {
    attributes,
    loading: t1,
    productType
  } = t0;
  const loading = t1 === undefined ? false : t1;
  if (loading) {
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <div className="[border-top:1px_solid_#e5e5e5] mt-14 pt-14 [content-visibility:auto] [contain-intrinsic-size:0] max-[1023px]:mt-12"><div className="text-xl font-bold mt-[5px] mx-0 mb-2.5"><Placeholder type="rect" loading={true} style={{
            height: "28px",
            width: "91px"
          }} /></div><div>{[1, 2, 3].map(_temp)}</div></div>;
      $[0] = t2;
    } else {
      t2 = $[0];
    }
    return t2;
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <h2 className="text-xl font-bold mt-[5px] mx-0 mb-2.5">Features</h2>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== attributes || $[3] !== productType) {
    let t4;
    if ($[5] !== productType) {
      t4 = attribute => <Attribute key={attribute} attribute={attribute} productType={productType} />;
      $[5] = productType;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    t3 = attributes.map(t4);
    $[2] = attributes;
    $[3] = productType;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <div className="[border-top:1px_solid_#e5e5e5] mt-14 pt-14 [content-visibility:auto] [contain-intrinsic-size:0] max-[1023px]:mt-12">{t2}<div>{t3}</div></div>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
PDPSellingAttributesUI.propTypes = {
  attributes: PropTypes.arrayOf(PropTypes.string),
  loading: PropTypes.bool,
  productType: PropTypes.string
};
export default PDPSellingAttributesUI;
function _temp(index) {
  return <div className="flex items-center justify-start mx-0 my-[5px]" key={`${index}`}><Placeholder type="rect" loading={true} style={{
      height: "42px",
      width: "42px"
    }} /><Placeholder type="rect" loading={true} style={{
      height: "42px",
      marginRight: "0",
      maxWidth: "500px"
    }} /></div>;
}